export interface IPronounModel {
  pronounId: number;
  name: string;
}

export class PronounModel implements IPronounModel {
  pronounId: number;
  name: string;

  constructor(params: Partial<IPronounModel> = {} as PronounModel) {
    const { pronounId = 0, name = '' } = params;

    this.pronounId = pronounId;
    this.name = name;
  }
}
